<template>
  <div class="row">
    <div class="page-title">
      <div class="row">
        <div class="col-sm-6 col-12">
          <h2>
            Service Jurisdictions
          </h2>
        </div>
        <div class="col-sm-6 col-12 text-end">
          <a class="btn btn-primary align-items-center" href="/admin/service-jurisdictions/new">
            <i class="fa-regular fa-square-plus"></i>
            Add New
          </a>
        </div>
      </div>
    </div>

    <div class="col-xl-12 xl-100 box-col-6">
      <div class="card">
        <div class="card-body social-list filter-cards-view">
          <div>
            <DataTable
              :ajax="{ url: `/api/datatable/service-jurisdictions` }"
              ref="jurisdictionsDataTable" class="table-responsive display" :columns="jurisdictionColumns" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import {activeBadgeRender} from '../utility/DatatableRenderer';

DataTable.use(DataTablesCore);

const jurisdictionsDataTable = ref(null);

const jurisdictionColumns = [
  { data: 'name', title: 'Name' },
  { data: 'serviceArea.name', title: 'Service Area', render: (data, type, row) => {
    return row.serviceArea ? row.serviceArea.name : '<span class="text-muted">Not Assigned</span>';
  }},
  { data: 'serviceAreaAllowance', title: 'Allowance (km)', render: (data) => {
    return data ? `${data} km` : 'N/A';
  }},
  { data: 'commissionPercentage', title: 'Commission', render: (data) => {
    return data !== null && data !== undefined ? `${data}%` : '0%';
  }},
  { data: 'active', title: 'Status', render: activeBadgeRender },
  { title: 'Action', orderable: false, searchable: false, render:  (data, type, row, meta) => {
    return `<a class="btn btn-sm btn-outline-primary" href="/admin/service-jurisdictions/${row.id}">
                <i class="fas fa-pen-to-square"></i> Edit</a>`}
  }
];

</script>
